import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { useAppContent } from '~/hooks';
import { Cover } from '~/types/cover';

const ReviewGlass: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.glass' });

  const glassReviewList = [
    {
      label: getTextContent('coverAdded'),
      data: '',
    },
  ];

  return (
    <ReviewList
      list={
        glassReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.Glass}
    />
  );
};

export default ReviewGlass;
